import type { IconSvgObject } from './types';

const CornerRightDownIcon: IconSvgObject = [
  ["path", { d: "M15 19.002L15 12.002C15 8.23072 15 6.3451 13.8284 5.17353C12.6569 4.00195 10.7712 4.00195 7 4.00195L4 4.00195", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20 15.002C20 15.002 16.3176 20.0019 15 20.002C13.6824 20.002 10 15.002 10 15.002", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CornerRightDownIcon;
